import React from 'react';
import { Container, Stack, useTheme } from '@mui/material';

import { Props } from './props';

const FormContainerWrapperView: React.FC<Props> = (props) => {
  const {
    children,
    stackProps,
    stackStyle,
    containerStyle,
    stackClassname,
    containerClassname,
    ...rest
  } = props;
  const theme = useTheme();
  return (
    <Container
      sx={{
        marginLeft: 0,
        px: 0,
        ...containerStyle,
      }}
      className={containerClassname}
      {...rest}
    >
      <Stack
        direction="column"
        sx={{
          borderRadius: '10px',
          boxShadow:
            '0px 1px 6px rgba(76, 78, 100, 0.1), 0px 1px 2px rgba(76, 78, 100, 0.1)',
          display: 'flex',
          px: '1.4rem',
          border: '1px solid',
          borderColor: theme.palette.divider,
          background: theme.palette.background.paper,
          ...stackStyle,
        }}
        className={stackClassname}
        {...stackProps}
      >
        {children}
      </Stack>
    </Container>
  );
};

export const FormContainerWrapper = FormContainerWrapperView;
export default FormContainerWrapperView;
